import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, message, FormInstance } from 'antd';

import { useOwnerDetails } from 'api/owners';
import { hostawayApi } from 'api/partners';
import { Spin, Typography, Modal, InputUIKit } from 'ui-kit';

import './PartnerConnect.scss';
import { useSignedUser } from 'api/auth';

HostawayConnect.propTypes = {
  visible: PropTypes.bool,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

export default function HostawayConnect({ visible, onSubmit, onClose }) {
  const { data: user } = useSignedUser();
  const { invalidate } = useOwnerDetails(user?.owner_id);
  const [formDetails, setFormDetails] = useState({ accountId: '', apiKey: '' });
  const [isLoading, setLoading] = useState(false);

  const formRef = useRef<FormInstance | null>(null);

  const handleSubmit = () => {
    formRef.current.validateFields().then((values) => {
      setLoading(true);
      hostawayApi
        .createOauth({ accountId: values.accountId, apiKey: values.apiKey })
        .then((res) => {
          if (res.ok) {
            message.success('Client credentials saved successfully!');
            setFormDetails({ accountId: values.accountId, apiKey: values.apiKey });
            invalidate();
            onSubmit();
            setLoading(false);
          } else {
            message.error(res.data || 'Error adding credentials!');
          }
        });
    });
  };

  return (
    <Modal
      visible={visible}
      onOk={handleSubmit}
      onCancel={onClose}
      okText="Submit"
      okButtonProps={{ disabled: isLoading }}
      cancelButtonProps={{ hidden: true, disabled: true }}
    >
      <Spin spinning={isLoading}>
        <Typography variant="body1">Add your Hostaway credentials here:</Typography>

        <Form ref={formRef} layout="vertical" initialValues={formDetails}>
          <div>
            <Form.Item
              name="accountId"
              rules={[
                {
                  required: true,
                  message: 'Please input your Accound ID',
                },
              ]}
            >
              <InputUIKit placeholder="Account ID" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              name="apiKey"
              rules={[
                {
                  required: true,
                  message: 'Please input your API Key',
                },
              ]}
            >
              <InputUIKit placeholder="API Key" />
            </Form.Item>
          </div>
        </Form>
        <Typography variant="caption">
          Don’t have credentials yet? Head over to your{' '}
          <a
            href="https://dashboard.hostaway.com/v3/settings/hostaway-api"
            target="_blank"
            rel="noreferrer"
            className="Integration_external_link"
          >
            Hostaway Public API page
          </a>{' '}
          and hit &quot;Create&quot;.
        </Typography>
      </Spin>
    </Modal>
  );
}
